<template>
  <div class="header-portal">
    <v-toolbar color="primary" dark fixed app>
      <a href="#/" class="logo" @click="portalEmmit('principal')">
        <v-img :src="require('@/assets/images/logo.png')" width="150"></v-img>
      </a>
      <v-spacer></v-spacer>
      <!-- muestra el ambiente -->
      <template v-if="enviroment && enviroment != ''">
        <span class="hidden-md-and-down rounded text-center warning-band px-8 py-1">
          <span class="white rounded font-weight-bold px-2 black--text">{{ enviroment }}</span>
        </span>
        <v-spacer></v-spacer>
      </template>
      <v-btn fab flat small @click="portalEmmit('principal')" class="hidden-md-and-up secondary">
        <v-icon>home</v-icon>
      </v-btn>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn @click="portalEmmit('principal')" flat :class="isPrincipal?'primary lighten-1':'primary'">
          <v-icon>home</v-icon>&nbsp;Principal
        </v-btn>
        <v-btn @click="portalEmmit('informacion')" flat :class="isInformacion?'primary lighten-1':'primary'">
          <v-icon>info</v-icon>&nbsp;Información
        </v-btn>
        <v-btn @click="portalEmmit('preguntas')" flat :class="isPreguntas?'primary lighten-1':'primary'">
          <v-icon>help</v-icon>&nbsp;Preguntas Frecuentes
        </v-btn>
        <v-btn @click="portalEmmit('contacto')" flat :class="isContacto?'primary lighten-1':'primary'">
          <v-icon>call</v-icon>&nbsp;Contacto
        </v-btn>
        <!-- <v-btn @click="portalEmmit('manuales')" flat :class="isManuales?'primary lighten-1':'primary'">
          <v-icon>description</v-icon>&nbsp;Manuales
        </v-btn> -->
        <div v-if="this.$router.history.current.path !== '/'">
       <v-btn
          fab
          color="primary"
          bottom
          left
          absolute
          @click="volver()"
        >
          <v-icon>arrow_back_ios</v-icon>
        </v-btn> 
        </div>
      </v-toolbar-items>
      <v-menu class="hidden-md-and-up">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list shaped>          
          <li>
            <v-btn @click="portalEmmit('informacion')" flat>
              <v-icon>info</v-icon>&nbsp;Información
            </v-btn>
          </li>
          <li>
            <v-btn @click="portalEmmit('preguntas')" flat>
              <v-icon>help</v-icon>&nbsp;Preguntas Frecuentes
            </v-btn>
          </li>
          <li>
            <v-btn @click="portalEmmit('contacto')" flat>
              <v-icon>call</v-icon>&nbsp;Contacto
            </v-btn>
          </li>
          <!-- <li>
            <v-btn @click="portalEmmit('manuales')" flat>
              <v-icon>description</v-icon>&nbsp;Manuales
            </v-btn>
          </li> -->
        </v-list>
      </v-menu>
    </v-toolbar>
    <!-- <v-dialog
      v-model="dialogInformacion"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title><h4>Información</h4>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogInformacion = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
          <v-flex xs8>
          <v-alert :value='true' type='info' outline><b>RECUERDE:</b></v-alert>
          </v-flex>     
          </v-layout>
          <br /><p align='justify'>
<b>Plazos para la presentación de la Declaración Jurada de Bienes y Rentas :</b><br> Debe ser presentada por las Servidoras y Servidores Públicos según corresponda, antes (hasta el primer día hábil del ejercicio del Cargo), durante (en el mes de su nacimiento si reside en capitales de departamento, y si reside fuera de las capitales de departamento, contarán adicionalmente con el mes siguiente de su nacimiento) y después; del ejercicio del cargo (hasta 30 días calendario computables desde el primer día de su desvinculación,). Según DECRETO SUPREMO 1233 CAPÍTULO I, ARTÍCULO 4.- (Presentación de la Declaración). 
        </p></v-card-text>
      </v-card>
    </v-dialog> -->
    <!-- <v-dialog
      v-model="dialogPregunta"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title><h4>Preguntas Frecuentes</h4>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogPregunta = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <br />
          <v-layout row wrap>
            <v-flex xs12>
              <p align='justify'><b>¿Qué es la Declaración Jurada?</b><br><br>
              Es una declaración juramentada que se realiza por mandato legal y constitucional, en la que un funcionario público informa sobre todos los ingresos, bienes y rentas que posee o percibe.</p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog> -->
    <!-- <v-dialog
      v-model="dialogContacto"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title><h4>Contacto</h4>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogContacto = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
           <v-layout row wrap>
         <v-flex xs12>
        <b>   Acerca del sitio  </b><br>
    <p align='justify'>El Sistema de Declaración Jurada de Bienes y Rentas es un servicio prestado por la Contraloría General del Estado Plurinacional de Bolivia </p>
         </v-flex> 
        </v-layout>
        <br>
        <v-layout wrap>
        <v-flex xs12 md3 sm6>
           <b>   Oficina Central - La Paz </b><br>
    <b>Dirección:</b> Calle Colón esquina Indaburo<br>
   <b> Teléfono:</b> 2177400<br>
        </v-flex>
        <v-flex xs12 md3 sm6>
           <b>  Gerencia Departamental - Beni </b><br>
    <b>Dirección:</b> Av. Nicolás Suarez Nº 517<br>
        </v-flex>
        <v-flex xs12 md3 sm6>
           <b>  Gerencia Departamental - Chuquisaca </b><br>
    <b>Dirección:</b> Calle Bolívar Nº 701 esq. Dalence<br>
        </v-flex>
         <v-flex xs12 md3 sm6>
           <b>  Gerencia Departamental - Cochabamba </b><br>
    <b>Dirección:</b>  Calle Jordán Nº 351<br>
        </v-flex>
        </v-layout>
        <br>
        <v-layout row wrap>
           <v-flex xs12 md3 sm6>
           <b>  Gerencia Departamental - Oruro </b><br>
          <b>Dirección:</b>  Calle Caro Nº 307<br>
        </v-flex>
          <v-flex xs12 md3 sm6>
           <b>  Gerencia Departamental - Pando </b><br>
          <b>Dirección:</b>  Av. 9 de Febrero s/n<br>
        </v-flex>
        <v-flex xs12 md3 sm6>
           <b>  Gerencia Departamental - Potosí </b><br>
          <b>Dirección:</b>  Calle Frías Nº 66<br>
        </v-flex>
        <v-flex xs12 md3 sm6>
           <b>  Gerencia Departamental - Santa Cruz </b><br>
          <b>Dirección:</b>  2º Anillo/Av. Trinidad Nº 706<br>
        </v-flex>
        </v-layout>
        <br>
        <v-layout row wrap>
           <v-flex xs12 md3 sm6>
           <b>  Gerencia Departamental - Tarija </b><br>
          <b>Dirección:</b>  Calle La Madrid E Nº 182<br>
        </v-flex>
        </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </div>
</template>  
<script>
export default {
  data: () => ({
    enviroment: process.env.ENVIROMENT,
    dialogInformacion: false,
    dialogPregunta: false,
    dialogContacto: false,
    isPrincipal: true,
    isPreguntas: false,
    isInformacion: false,
    isContacto: false,
    isBaseLegal: false,
    isManuales: false
  }),
  mounted () {
    this.$root.$on('onOpcionPortal', (value) => {
      this.cambiarOpcionPortal(value);
    });
  },
  methods: {
    volver () {
      if (this.$router.history.current.path === '/') {
        this.$router.push('/');
      } else {
        this.$router.go(-1);
      }
    },
    portalEmmit (value) {
      this.cambiarOpcionPortal(value);
      this.$root.$emit('onOpcionPortal', value);
    },
    cambiarOpcionPortal (value) {
      switch (value) {
        case 'principal':
          this.isPrincipal = true;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'preguntas':
          this.isPrincipal = false;
          this.isPreguntas = true;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'informacion':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = true;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'contacto':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = true;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'base-legal':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = true;
          this.isManuales = false;
          break;
        case 'manuales':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = true;
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="scss">
.warning-band {
  background-image:
    repeating-linear-gradient(
      135deg,
      gold,
      gold 15px,
      black 15px,
      black 30px /* determines size */
    );
}
.header-portal {
  overflow: hidden;
  background-color: #ffffff;
  padding: 0px 10px;
  background-size: cover;
}

.header-portal a {
  float: left;
  color: white;
  text-align: center;
  padding: 12px;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
  border-radius: 2px;
}

.header-portal a.logo {
  font-size: 18px;
  font-weight: bold;
  padding-left: 46px;
  .image {
    width: 281px;
    height: 55px;
    background-image: url(../../assets/images/logo.png);
    float: inherit;
  }
  .texto {
    margin-bottom: 16px;
    padding: 15px;
    width: 311px;
  }
}
.header-portal-right {
  float: right;
  padding: 15px;
}
@media screen and (max-width: 600px) {
  .header-portal a {
    float: none;
    display: block;
    text-align: left;
    line-height: 15px;
    padding: 5px;
  }

  .header-portal-right {
    float: none;
    padding: 0px;
  }
  .header-portal a.logo {
    font-size: 18px;
    font-weight: bold;
    padding-left: 0px;
    .image {
      width: 53px;
      height: 55px;
      background-image: url(../../assets/images/logo.png);
      float: inherit;
    }
    .texto {
      display: none;
    }
    .opcion-declarar {
      padding-top: 15%;
      padding-bottom: 15%;
      margin-left: 27%;
    }
  }
  /*.portal-button {
    background: linear-gradient(to bottom, #007dc1 5%, #0061a7 100%) !important;
    background-color: #007dc1 !important;
    display: inline-block;
    cursor: pointer;
    font-family: Arial;
    font-size: 18px;
    padding: 20px 26px;
    text-decoration: none;
    color: white !important;
    padding-bottom: 45px;
  }*/
}
</style>


// WEBPACK FOOTER //
// src/components/djbrd/headerPortal.vue